import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

export const TextInputField = (props: TextFieldProps): React.ReactElement => {
    return <TextField fullWidth required margin="dense" {...props} />;
};
